import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4118441_14vio1p5gw2.js',
});

export default FontIcon;